import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Box, Grid, Typography, useMediaQuery, useTheme, IconButton } from '@material-ui/core';

import about from '../resource/about.svg';
import about_mobile from '../resource/about-mobile.svg';
import AboutUsBanner from './AboutUsBanner';

import { Link } from 'react-scroll';
import { motion } from "framer-motion";

const bounceTransition = {
    y: {
        duration: 1,
        yoyo: 3,
        ease: "easeIn",
    },
    backgroundColor: {
        duration: 0,
        yoyo: 3,
        ease: "easeOut",
        repeatDelay: 1,
    },
};

const useStyles = makeStyles((theme) => ({

    section: {
        padding: '4em',
        height: '100vh',

        backgroundImage: `url(${about})`,
        backgroundSize: '70%,70%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right bottom',
    },

    sectionMobile: {
        paddingLeft: '2em',
        paddingRight: '2em',
        paddingTop: '2em',
        height: '100vh',

        backgroundImage: `url(${about_mobile})`,
        backgroundSize: '100%,700%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom',
    },

    logos: {
        height: '4em',
    },
    dummys: {
        height: '100vh'
    }
}));

const Down = (props) => (<motion.div {...props}></motion.div>);


const AboutUs = ({ ref }) => {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));


    return (

        <Grid container direction="column" className={matchesSM ? classes.sectionMobile : classes.section}>

            {
                !matchesSM &&
                <Grid item style={{ height: '8em' }}></Grid>
            }

            {
                matchesSM &&
                <Grid item style={{ height: '4em' }}></Grid>
            }


            {/*Titulo y descripciones*/}

            <Grid item >
                <Grid container direction="column">
                    <Grid item xs>
                        <Typography variant={matchesSM ? "h5" : "h3"} align="center">
                            <Box fontWeight={750} lineHeight={2} letterSpacing={matchesSM ? 1 : 2} color={theme.palette.arenco.darkBlue} align="left">
                                Acerca de nosotros
                            </Box>
                        </Typography>
                    </Grid>
                    <Grid item xs={!matchesSM && 6} >
                        <Typography variant={matchesSM ? 'body1' : 'h6'}>
                            <Box lineHeight={1.5} color={theme.palette.arenco.darkBlue} fontWeight={500} align="left">
                                Somos un equipo con vasta experiencia en desarrollo e implementación
                                de soluciones informáticas para el área de salud. Esto nos permite
                                identificar las necesidades específicas de cada cliente,
                                y combinar la vanguardia tecnológica
                                con el diseño de plataformas sólidas y escalables.
                            </Box>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>


            <Grid item xs container direction="column" justify="flex-end" >

                {
                    !matchesSM &&
                    <Grid item container alignItems="flex-end">
                        <Grid item xs={4} align="center">
                            <AboutUsBanner />
                        </Grid>
                        <Grid item xs={4} align="center">
                            <Down transition={bounceTransition}
                                animate={{
                                    y: ["0em", "4em"],
                                    //backgroundColor: ["#9b59b6", "#f1c40f"],
                                }}
                            >
                                <Link style={{
                                    cursor: 'pointer',
                                }} to="contact" spy={true} smooth={true} offset={0} duration={1000} delay={300}>
                                    <IconButton
                                        color="primary"
                                        disableFocusRipple
                                        disableRipple>

                                    </IconButton>
                                </Link>
                            </Down>
                        </Grid>
                    </Grid>
                }

                {/*
                    matchesSM &&
                    <Grid item  >
                        <AboutUsBanner />
                    </Grid>
            */}

            </Grid>



        </Grid >
    );
};

export default AboutUs;